import { RootSelector, getStore } from '../../reducers';
import { SortingShape, SortingOrder, SortingFieldKey } from './model';
import { createSelector } from '@reduxjs/toolkit';

export const getSorting: RootSelector<SortingShape> = createSelector(
  getStore,
  (state) => state.sorting,
);

export const getSortingOrder: RootSelector<SortingOrder> = createSelector(
  getSorting,
  (sorting) => sorting.order,
);

export const getSortingFieldKey: RootSelector<SortingFieldKey> = createSelector(
  getSorting,
  (sorting) => sorting.fieldKey,
);
